import React, { useState } from 'react';

const PopupSubscription: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(false);

  return (
    <div id="popup" className={`popup-overlay ${visible ? '' : 'd-none'}`}>
      <div className="popup-content" style={{ backgroundImage: "url('/assets/img/popup/popup-bg.png')" }}>
        <img src="/assets/img/popup/img-1-1.jpg" alt="popup" className="popup-img" />
        <div className="popup-form">
          <span className="close-btn" id="close-popup" onClick={() => setVisible(false)}>X</span>
          <h3 className="popup-title"><span>subscribe</span> to get access</h3>
          <p className="popup-text">Subscribe to our newsletter and we will ship 20% discount code today</p>
          <input className="popup-input" type="email" placeholder="Enter your Email..." />
          <button className="vs-btn">Submit</button>
          <p className="no-thanks">No thanks</p>
        </div>
      </div>
    </div>
  );
};

export default PopupSubscription;
